import React, { useMemo, useContext } from 'react';

import { ReactComponent as IconTermostatSymbol } from 'images/device/symbol/hinava_gradient/termostat.svg';

import { ReactComponent as IconStatusCoolingAr } from 'images/device/status-text-icon/cooling-ar.svg';
import { ReactComponent as IconStatusHeatingAr } from 'images/device/status-text-icon/heating-ar.svg';
import { ReactComponent as IconStatusFanAr } from 'images/device/status-text-icon/fan-ar.svg';
// import { ReactComponent as IconStatusAntiFreezeAr } from 'images/device/status-text-icon/anti-freeze-ar.svg';
// import { ReactComponent as IconStatusAutoAr } from 'images/device/status-text-icon/auto-ar.svg';
// import { ReactComponent as IconStatusEcoAr } from 'images/device/status-text-icon/eco-ar.svg';
// import { ReactComponent as IconStatusManualAr } from 'images/device/status-text-icon/manual-ar.svg';
// import { ReactComponent as IconStatusNormalAr } from 'images/device/status-text-icon/normal-ar.svg';

import { ReactComponent as IconStatusCoolingFa } from 'images/device/status-text-icon/cooling-fa.svg';
import { ReactComponent as IconStatusHeatingFa } from 'images/device/status-text-icon/heating-fa.svg';
import { ReactComponent as IconStatusFanFa } from 'images/device/status-text-icon/fan-fa.svg';
import { ReactComponent as IconStatusAntiFreezeFa } from 'images/device/status-text-icon/anti-freeze-fa.svg';
import { ReactComponent as IconStatusAutoFa } from 'images/device/status-text-icon/auto-fa.svg';
import { ReactComponent as IconStatusEcoFa } from 'images/device/status-text-icon/eco-fa.svg';
import { ReactComponent as IconStatusManualFa } from 'images/device/status-text-icon/manual-fa.svg';
import { ReactComponent as IconStatusNormalFa } from 'images/device/status-text-icon/normal-fa.svg';

import { ReactComponent as IconStatusCooling } from 'images/device/status-text-icon/cool.svg';
import { ReactComponent as IconStatusHeating } from 'images/device/status-text-icon/heat.svg';
import { ReactComponent as IconStatusFan } from 'images/device/status-text-icon/fan.svg';
import { ReactComponent as IconStatusAntiFreeze } from 'images/device/status-text-icon/anti-freeze.svg';
import { ReactComponent as IconStatusAuto } from 'images/device/status-text-icon/auto.svg';
import { ReactComponent as IconStatusEco } from 'images/device/status-text-icon/eco.svg';
import { ReactComponent as IconStatusManual } from 'images/device/status-text-icon/manual.svg';
import { ReactComponent as IconStatusNormal } from 'images/device/status-text-icon/normal.svg';

// small icon
import { ReactComponent as IconScenarioLeave } from 'images/device/thermostat/device_list/scenario_leave.svg';
import { ReactComponent as IconScenarioManual } from 'images/device/thermostat/device_list/scenario_manual.svg';
import { ReactComponent as IconScenarioSleep } from 'images/device/thermostat/device_list/scenario_sleep.svg';
import { ReactComponent as IconScenarioTurbo } from 'images/device/thermostat/device_list/scenario_turbo.svg';
import { ReactComponent as IconSpeedAuto } from 'images/device/thermostat/device_list/speed_auto.svg';
import { ReactComponent as IconSpeedFast } from 'images/device/thermostat/device_list/speed_fast.svg';
import { ReactComponent as IconSpeedMedium } from 'images/device/thermostat/device_list/speed_medium.svg';
import { ReactComponent as IconSpeedSlow } from 'images/device/thermostat/device_list/speed_slow.svg';
import { ReactComponent as IconSpeedOff } from 'images/device/thermostat/device_list/speed_off.svg';
import { ReactComponent as IconPumpOn } from 'images/device/thermostat/device_list/pump_on.svg';
import { ReactComponent as IconPumpOff } from 'images/device/thermostat/device_list/pump_off.svg';
import { ReactComponent as IconHinavaTurbo } from 'images/device/thermostat/device_list/hinava_turbo.svg';
// small gray icon
import { ReactComponent as IconScenarioLeaveGray } from 'images/device/thermostat/device_detail_gray/scenario_leave.svg';
import { ReactComponent as IconScenarioManualGray } from 'images/device/thermostat/device_detail_gray/scenario_manual.svg';
import { ReactComponent as IconScenarioSleepGray } from 'images/device/thermostat/device_detail_gray/scenario_sleep.svg';
import { ReactComponent as IconScenarioTurboGray } from 'images/device/thermostat/device_detail_gray/scenario_turbo.svg';
import { ReactComponent as IconSpeedAutoGray } from 'images/device/thermostat/device_detail_gray/speed_auto.svg';
import { ReactComponent as IconSpeedFastGray } from 'images/device/thermostat/device_detail_gray/speed_fast.svg';
import { ReactComponent as IconSpeedMediumGray } from 'images/device/thermostat/device_detail_gray/speed_medium.svg';
import { ReactComponent as IconSpeedSlowGray } from 'images/device/thermostat/device_detail_gray/speed_slow.svg';
import { ReactComponent as IconSpeedOffGray } from 'images/device/thermostat/device_detail_gray/speed_off.svg';
import { ReactComponent as IconPumpOnGray } from 'images/device/thermostat/device_detail_gray/pump_on.svg';
import { ReactComponent as IconPumpOffGray } from 'images/device/thermostat/device_detail_gray/pump_off.svg';
import { ReactComponent as IconHinavaTurboGray } from 'images/device/thermostat/device_detail_gray/hinava_turbo.svg';

import { ReactComponent as IconThreeDotsLoadingGray } from 'images/general/three-dots-loading-gray.svg';
import { ReactComponent as IconThreeDotsLoadingGradient } from 'images/general/three-dots-loading-gradient.svg';

import { SednaInfo, MarsusInfo, DeviceType, HinavaEcoThermostatInfo } from 'app/model/Device';
import { LocalizationContext } from 'app/localization/Context';


export default function ThermostatButton({ device, showStates, waitingForChangeOn, waitingForChangeMode }) {
    const l = useContext(LocalizationContext);
    const s = l.strings;

    const setPoint = useMemo(() => {
        let noSetpoint = device.is_on && (device.set_point !== undefined);
        let blueColorForInactiveLine = false;
        if ((device.type === DeviceType.hinavaEcoThermostat) && (device.mode_setting === HinavaEcoThermostatInfo.mode.fan)) {
            noSetpoint = false;
            if (device.is_on)
                blueColorForInactiveLine = true;
        }
        if (noSetpoint) {
            const intPart = (device.set_point).toFixed(1).split(".")[0]
            const realPart = (device.set_point).toFixed(1).split(".")[1]
            return (
                <div className="set-point active">
                    <div className="int-part">{String(intPart)}</div>
                    <div className="float-part">.{realPart}</div>
                    <div className="sign-part"><div>˚</div><div>c</div></div>
                </div>
            )
        } else {
            return (
                <div className={"set-point inactive " + (blueColorForInactiveLine ? "blue" : "")}>
                    —
                </div>
            );
        }
    }, [device.is_on, device.mode_setting, device.set_point, device.type]);

    const shouldShowWaiting = (waitingForChangeOn && !waitingForChangeOn.ignoreWaiting) ||
        (waitingForChangeMode && !waitingForChangeMode.ignoreWaiting);

    // -------------------- mode --------------------
    const modeIcon = useMemo(() => {
        if (shouldShowWaiting) {
            if (device.is_on) {
                return <IconThreeDotsLoadingGradient className="dots-icon" />;
            } else {
                return <IconThreeDotsLoadingGray className="dots-icon" />;
            }
        }

        if (device.is_on) {
            switch (device.type) {
                case DeviceType.sedna:
                    switch (device.mode) {
                        case SednaInfo.mode.cooling:
                            if (l.language === 'en') {
                                return <IconStatusCooling className="status-text-or-icon" />;
                            } else if (l.language === 'fa') {
                                return <IconStatusCoolingFa className="status-text-or-icon" />;
                            } else {
                                return <IconStatusCoolingAr className="status-text-or-icon" />;
                            }
                        case SednaInfo.mode.heating:
                            if (l.language === 'en') {
                                return <IconStatusHeating className="status-text-or-icon" />;
                            } else if (l.language === 'fa') {
                                return <IconStatusHeatingFa className="status-text-or-icon" />;
                            } else {
                                return <IconStatusHeatingAr className="status-text-or-icon" />;
                            }
                        default:
                            return null;
                    }
                case DeviceType.hinavaEcoThermostat:
                    switch (device.mode_setting) {
                        case HinavaEcoThermostatInfo.mode.cooling:
                            if (l.language === 'en') {
                                return <IconStatusCooling className="status-text-or-icon" />;
                            } else if (l.language === 'fa') {
                                return <IconStatusCoolingFa className="status-text-or-icon" />;
                            } else {
                                return <IconStatusCoolingAr className="status-text-or-icon" />;
                            }
                        case HinavaEcoThermostatInfo.mode.heating:
                            if (l.language === 'en') {
                                return <IconStatusHeating className="status-text-or-icon" />;
                            } else if (l.language === 'fa') {
                                return <IconStatusHeatingFa className="status-text-or-icon" />;
                            } else {
                                return <IconStatusHeatingAr className="status-text-or-icon" />;
                            }
                        case HinavaEcoThermostatInfo.mode.fan:
                            if (l.language === 'en') {
                                return <IconStatusFan className="status-text-or-icon" />;
                            } else if (l.language === 'fa') {
                                return <IconStatusFanFa className="status-text-or-icon" />;
                            } else {
                                return <IconStatusFanAr className="status-text-or-icon" />;
                            }
                        default:
                            return null;
                    }
                case DeviceType.marsus:
                    switch (device.sub_type) {
                        case MarsusInfo.subType.fanCoil:
                            switch (device.mode) {
                                case MarsusInfo.fanCoil.mode.cool:
                                    if (l.language === 'en') {
                                        return <IconStatusCooling className="status-text-or-icon" />;
                                    } else if (l.language === 'fa') {
                                        return <IconStatusCoolingFa className="status-text-or-icon" />;
                                    } else {
                                        return null
                                    }
                                case MarsusInfo.fanCoil.mode.heat:
                                    if (l.language === 'en') {
                                        return <IconStatusHeating className="status-text-or-icon" />;
                                    } else if (l.language === 'fa') {
                                        return <IconStatusHeatingFa className="status-text-or-icon" />;
                                    } else {
                                        return null
                                    }
                                default:
                                    return null;
                            }
                        case MarsusInfo.subType.package:
                            switch (device.mode) {
                                case MarsusInfo.package.mode.normal:
                                    if (l.language === 'en') {
                                        return <IconStatusNormal className="status-text-or-icon" />;
                                    } else if (l.language === 'fa') {
                                        return <IconStatusNormalFa className="status-text-or-icon" />;
                                    } else {
                                        return null
                                    }
                                case MarsusInfo.package.mode.eco:
                                    if (l.language === 'en') {
                                        return <IconStatusEco className="status-text-or-icon" />;
                                    } else if (l.language === 'fa') {
                                        return <IconStatusEcoFa className="status-text-or-icon" />;
                                    } else {
                                        return null
                                    }
                                case MarsusInfo.package.mode.antiFreeze:
                                    if (l.language === 'en') {
                                        return <IconStatusAntiFreeze className="status-text-or-icon" />;
                                    } else if (l.language === 'fa') {
                                        return <IconStatusAntiFreezeFa className="status-text-or-icon" />;
                                    } else {
                                        return null
                                    }
                                default:
                                    return null;
                            }
                        case MarsusInfo.subType.cooler:
                            switch (device.mode) {
                                case MarsusInfo.cooler.mode.manual:
                                    if (l.language === 'en') {
                                        return <IconStatusManual className="status-text-or-icon" />;
                                    } else if (l.language === 'fa') {
                                        return <IconStatusManualFa className="status-text-or-icon" />;
                                    } else {
                                        return null
                                    }
                                case MarsusInfo.cooler.mode.auto:
                                    if (l.language === 'en') {
                                        return <IconStatusAuto className="status-text-or-icon" />;
                                    } else if (l.language === 'fa') {
                                        return <IconStatusAutoFa className="status-text-or-icon" />;
                                    } else {
                                        return null
                                    }
                                default:
                                    return null;
                            }
                        default:
                            return null;
                    }
                default:
                    return null;
            }


        } else {
            return <div className="device-off-label status-text-or-icon">{s.off}</div>;
        }
    }, [device, shouldShowWaiting, l.language, s.off]);

    // -------------------- left --------------------
    const iconL = useMemo(() => {
        switch (device.type) {
            case DeviceType.sedna:
                if (device.is_on) {
                    switch (device.motor_speed) {
                        case SednaInfo.motorSpeed.auto:
                            return IconSpeedAuto;
                        case SednaInfo.motorSpeed.low:
                            return IconSpeedSlow;
                        case SednaInfo.motorSpeed.medium:
                            return IconSpeedMedium;
                        case SednaInfo.motorSpeed.high:
                            return IconSpeedFast;
                        default:
                            return 'div';
                    }
                } else {
                    switch (device.motor_speed) {
                        case SednaInfo.motorSpeed.auto:
                            return IconSpeedAutoGray;
                        case SednaInfo.motorSpeed.low:
                            return IconSpeedSlowGray;
                        case SednaInfo.motorSpeed.medium:
                            return IconSpeedMediumGray;
                        case SednaInfo.motorSpeed.high:
                            return IconSpeedFastGray;
                        default:
                            return 'div';
                    }
                }
            case DeviceType.hinavaEcoThermostat:
                if (device.is_on) {
                    switch (device.fan_setting) {
                        case HinavaEcoThermostatInfo.fanSetting.auto:
                            return IconSpeedAuto;
                        case HinavaEcoThermostatInfo.fanSetting.low:
                            return IconSpeedSlow;
                        case HinavaEcoThermostatInfo.fanSetting.medium:
                            return IconSpeedMedium;
                        case HinavaEcoThermostatInfo.fanSetting.high:
                            return IconSpeedFast;
                        default:
                            return 'div';
                    }
                } else {
                    switch (device.fan_setting) {
                        case HinavaEcoThermostatInfo.fanSetting.auto:
                            return IconSpeedAutoGray;
                        case HinavaEcoThermostatInfo.fanSetting.low:
                            return IconSpeedSlowGray;
                        case HinavaEcoThermostatInfo.fanSetting.medium:
                            return IconSpeedMediumGray;
                        case HinavaEcoThermostatInfo.fanSetting.high:
                            return IconSpeedFastGray;
                        default:
                            return 'div';
                    }
                }
            case DeviceType.marsus:
                switch (device.sub_type) {
                    case MarsusInfo.subType.fanCoil:
                        if (device.is_on) {
                            switch (device.fan_speed) {
                                case MarsusInfo.fanCoil.fanSpeed.fast:
                                    return IconSpeedFast;
                                case MarsusInfo.fanCoil.fanSpeed.medium:
                                    return IconSpeedMedium;
                                case MarsusInfo.fanCoil.fanSpeed.slow:
                                    return IconSpeedSlow;
                                case MarsusInfo.fanCoil.fanSpeed.auto:
                                    return IconSpeedAuto;
                                default:
                                    return 'div';
                            }
                        } else {
                            switch (device.fan_speed) {
                                case MarsusInfo.fanCoil.fanSpeed.fast:
                                    return IconSpeedFastGray;
                                case MarsusInfo.fanCoil.fanSpeed.medium:
                                    return IconSpeedMediumGray;
                                case MarsusInfo.fanCoil.fanSpeed.slow:
                                    return IconSpeedSlowGray;
                                case MarsusInfo.fanCoil.fanSpeed.auto:
                                    return IconSpeedAutoGray;
                                default:
                                    return 'div';
                            }
                        }
                    case MarsusInfo.subType.package:
                        return 'div';
                    case MarsusInfo.subType.cooler:
                        if (device.is_on) {
                            switch (device.fan_speed) {
                                case MarsusInfo.cooler.fanSpeed.fast:
                                    return IconSpeedFast;
                                case MarsusInfo.cooler.fanSpeed.medium:
                                    return IconSpeedMedium;
                                case MarsusInfo.cooler.fanSpeed.off:
                                    return IconSpeedOff;
                                default:
                                    return 'div';
                            }
                        } else {
                            switch (device.fan_speed) {
                                case MarsusInfo.cooler.fanSpeed.fast:
                                    return IconSpeedFastGray;
                                case MarsusInfo.cooler.fanSpeed.medium:
                                    return IconSpeedMediumGray;
                                case MarsusInfo.cooler.fanSpeed.off:
                                    return IconSpeedOffGray;
                                default:
                                    return 'div';
                            }
                        }
                    default:
                        return 'div';
                }
            default:
                return 'div';
        }
    }, [device]);

    // -------------------- right --------------------
    const iconR = useMemo(() => {
        switch (device.type) {
            case DeviceType.sedna:
                if (device.is_on) {
                    switch (device.scenario) {
                        case SednaInfo.scenario.manual:
                            return IconScenarioManual;
                        case SednaInfo.scenario.away:
                            return IconScenarioLeave;
                        case SednaInfo.scenario.sleep:
                            return IconScenarioSleep;
                        case SednaInfo.scenario.turbo:
                            return IconScenarioTurbo;
                        default:
                            return 'div';
                    }
                } else {
                    switch (device.scenario) {
                        case SednaInfo.scenario.manual:
                            return IconScenarioManualGray;
                        case SednaInfo.scenario.away:
                            return IconScenarioLeaveGray;
                        case SednaInfo.scenario.sleep:
                            return IconScenarioSleepGray;
                        case SednaInfo.scenario.turbo:
                            return IconScenarioTurboGray;
                        default:
                            return 'div';
                    }
                }
            case DeviceType.marsus:
                switch (device.sub_type) {
                    case MarsusInfo.subType.cooler:
                        if (device.is_on) {
                            if (device.pump) {
                                return IconPumpOn;
                            } else {
                                return IconPumpOff;
                            }
                        } else {
                            if (device.pump) {
                                return IconPumpOnGray;
                            } else {
                                return IconPumpOffGray;
                            }
                        }
                    default:
                        return 'div';
                }
            case DeviceType.hinavaEcoThermostat:
                if (device.is_on) {
                    if (device.turbo_setting) {
                        return IconHinavaTurbo;
                    } else {
                        return IconScenarioManual;
                    }
                } else {
                    if (device.turbo_setting) {
                        return IconHinavaTurboGray;
                    } else {
                        return IconScenarioManualGray;
                    }
                }
            default:
                return 'div';
        }
    }, [device]);

    if (!showStates) {
        return (
            <div className="device-button">
                <IconTermostatSymbol />
                <div className="status-placeholder" />
            </div>
        );
    } else {
        return (
            <div className="device-button">
                <div className="thermostat-data">
                    <div className="icons">
                        {React.createElement(iconL, { className: "icon" })}
                        {React.createElement(iconR, { className: "icon" })}
                    </div>

                    {setPoint}
                </div>
                {modeIcon}
            </div>
        );
    }
}